/*
 *
 * EasySplit  actions
 *
 */

import {
  DEFAULT_ACTION,
  SEARCH_VENDORS,
  SET_ACTIVE_NAVIGATION,
  ENABLE_LOADER,
  DISABLE_LOADER,
  SAVE_VENDORS,
  UPDATE_TABLE_DATA,
  UPDATE_FILTERS,
  RESET_FILTERS,
  BATCH_DOWNLOAD,
  RESET_BATCH_UPLOAD_RESPONSE,
  BATCH_UPLOAD_SAVE_RESPONSE,
  BATCH_UPLOAD_SUBMIT,
  CREATE_VENDOR,
  CREATE_VENDOR_SAVE_RESPONSE,
  UPDATE_VENDOR,
  UPDATE_VENDOR_SAVE_RESPONSE,
  SETTLEMENT_CONFIG,
  SAVE_SETTLEMENT_CONFIG,
  VENDOR_DATA_BY_ID,
  SAVE_VENDOR_DATA_BY_ID,
  RESET_VENDOR_DATA_BY_ID,
  RESET_PAGE,
  RESET_DATA,
  GET_VENDOR_OD_BALANCE,
  INITIATE_VENDOR_OD,
  CREATE_KYC,
  DOWNLOAD_DOC,
  GET_VENDOR_KYC_DOCS,
  GET_BUSINESS_INFO,
  CREATE_VENDOR_NEW,
  UPDATE_VENDOR_NEW,
  GET_DOCS_BY_USER,
  SAVE_VENDOR_DOCS,
  UPLOAD_VENDOR_DOCS,
  VERIFY_PAN,
  VERIFY_CIN,
  VERIFY_GST,
  CREATE_ONBOARDING_USER,
} from './constants';

export function defaultAction() {
  return {
    type: DEFAULT_ACTION,
  };
}

export function setActiveNavigation(activeNavigation) {
  return {
    type: SET_ACTIVE_NAVIGATION,
    data: activeNavigation,
  };
}

export function searchEasySplitVendorsAction(data) {
  return {
    type: SEARCH_VENDORS,
    data,
  };
}

export function saveEasySplitVendorsAction(data) {
  return {
    type: SAVE_VENDORS,
    payload: data,
  };
}

export function enableLoaderAction() {
  return {
    type: ENABLE_LOADER,
  };
}

export function disableLoaderAction() {
  return {
    type: DISABLE_LOADER,
  };
}

export function updateTableDataAction(data) {
  return {
    type: UPDATE_TABLE_DATA,
    data,
  };
}

export function updateFilters(data) {
  return {
    type: UPDATE_FILTERS,
    data,
  };
}

export function resetFiltersAction(data) {
  return {
    type: RESET_FILTERS,
    data,
  };
}

export function createVendorAction(data) {
  return {
    type: CREATE_VENDOR,
    payload: data,
  };
}

export function createVendorSaveResponseAction(response) {
  return {
    type: CREATE_VENDOR_SAVE_RESPONSE,
    response,
  };
}

export function updateVendorAction(data) {
  return {
    type: UPDATE_VENDOR,
    payload: data,
  };
}

export function updateVendorSaveResponseAction(response) {
  return {
    type: UPDATE_VENDOR_SAVE_RESPONSE,
    response,
  };
}

export function getSettlementConfigAction() {
  return {
    type: SETTLEMENT_CONFIG,
  };
}

export function saveSettlementConfigAction(data) {
  return {
    type: SAVE_SETTLEMENT_CONFIG,
    data,
  };
}
export function batchUploadSubmitAction(data) {
  return {
    type: BATCH_UPLOAD_SUBMIT,
    data,
  };
}

export function batchUploadSaveResponseAction(data) {
  return {
    type: BATCH_UPLOAD_SAVE_RESPONSE,
    data,
  };
}

export function resetBatchUploadResponse() {
  return {
    type: RESET_BATCH_UPLOAD_RESPONSE,
  };
}

export function batchDownloadAction(data) {
  return {
    type: BATCH_DOWNLOAD,
    data,
  };
}

export function vendorDataByIdAction(data) {
  return {
    type: VENDOR_DATA_BY_ID,
    data,
  };
}

export function saveVendorDataByIdAction(data) {
  return {
    type: SAVE_VENDOR_DATA_BY_ID,
    data,
  };
}

export function resetVendorDataByIdAction(data) {
  return {
    type: RESET_VENDOR_DATA_BY_ID,
    data,
  };
}

export function resetPageAction() {
  return {
    type: RESET_PAGE,
  };
}

export function resetDataAction() {
  return {
    type: RESET_DATA,
  };
}

export function getVendorOdBalanceAction(data) {
  return {
    type: GET_VENDOR_OD_BALANCE,
    data,
  };
}

export function initiateVendorOdAction(data) {
  return {
    type: INITIATE_VENDOR_OD,
    data,
  };
}

export function createKycAction(data) {
  return {
    type: CREATE_KYC,
    payload: data,
  };
}

export function createVendorNewAction(data) {
  return {
    type: CREATE_VENDOR_NEW,
    payload: data,
  };
}

export function updateVendorNewAction(data) {
  return {
    type: UPDATE_VENDOR_NEW,
    payload: data,
  };
}

export function downloadDocAction(data) {
  return {
    type: DOWNLOAD_DOC,
    data,
  };
}

export function getKycDocsAction(data) {
  return {
    type: GET_VENDOR_KYC_DOCS,
    data,
  };
}

export function getBusinessInfoAction(data) {
  return {
    type: GET_BUSINESS_INFO,
    data,
  };
}

export function getDocsByUserAction(data) {
  return {
    type: GET_DOCS_BY_USER,
    data,
  };
}

export function uploadVendorDocsAction(data) {
  return {
    type: UPLOAD_VENDOR_DOCS,
    data,
  };
}

export function saveVendorDocsAction(data) {
  return {
    type: SAVE_VENDOR_DOCS,
    data,
  };
}

export function verifyPanAction(data) {
  return {
    type: VERIFY_PAN,
    data,
  };
}

export function verifyCinAction(data) {
  return {
    type: VERIFY_CIN,
    data,
  };
}

export function verifyGstAction(data) {
  return {
    type: VERIFY_GST,
    data,
  };
}

export function createOnboardingUsersAction(data) {
  return {
    type: CREATE_ONBOARDING_USER,
    data,
  };
}
